export default function toSubscriptionName(SubscriptionUtils) {
  'ngInject';

  return function link(value) {
    return SubscriptionUtils.getSubscriptionName(value);
  };
}
